import styled from 'styled-components';

export const ProjectContainer = styled.div`
	position: relative;

	display: flex;
	flex-direction: column;
	align-items: center;

	width: 100%;

	> span,
	span.react-loading-skeleton {
		width: 100%;
		aspect-ratio: 4 / 3;
		border-radius: var(--border-radius);
	}

	.project-image {
		position: relative;

		width: 100%;
		aspect-ratio: 4 / 3;

		background: var(--color-surface);
		border: 1px solid var(--color-line);
		border-radius: var(--border-radius);

		img {
			position: absolute;
			top: 0;
			left: 0;

			/* display: none; */

			width: 100%;
			height: 100%;
			object-fit: cover;

			border-radius: var(--border-radius);
		}
	}

	.project-info {
		position: absolute;
		top: 0;
		left: 0;

		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: flex-end;
		gap: 0.8rem;

		width: 100%;
		height: 100%;
		padding: 3.2rem;

		background: rgb(0, 0, 0);
		background: linear-gradient(
			0deg,
			rgba(0, 0, 0, 1),
			rgba(0, 0, 0, 0.9),
			rgba(0, 0, 0, 0.8),
			rgba(0, 0, 0, 0.5)
		);

		opacity: 0;
		pointer-events: none;
		user-select: none;

		.actions {
			position: absolute;
			z-index: 5;
			top: 3.2rem;
			right: 3.2rem;

			display: flex;
			align-items: center;
			gap: 0.8rem;

			.action {
				padding: 0.8rem;

				border: 1px solid var(--color-line);
				border-radius: var(--border-radius);
				background: var(--color-background);

				cursor: pointer;
				transition: 0.2s;

				svg {
					font-size: calc(var(--text-size) + 0.4rem);
					/* color: #fff; */
				}

				&.active {
					svg {
						color: #fff;
						fill: #fff;
					}
				}

				&:hover {
					transform: scale(1.1);
				}
			}
		}

		.categories {
			display: flex;
			gap: 1.2rem;

			small {
				padding: 0.2rem 1.2rem;

				font-size: calc(var(--text-size) - 0.2rem);

				border-radius: 3rem;
				/* outline: 1px solid #fff; */
				background: rgba(255, 255, 255, 0.2);
				color: #fff;
			}
		}

		strong {
			color: var(--color-title);
			font-size: calc(var(--text-size) + 1.6rem);
		}

		p {
			font-size: var(--text-size);
			line-height: 1.5;

			display: -webkit-box;
			max-width: 100%;
			width: 100%;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		a {
			font-size: var(--text-size);

			&:hover {
				color: #fff;
			}
		}

		.button {
			margin-top: 2.8rem;
		}
	}

	&:hover {
		.project-info {
			opacity: 1;
			pointer-events: auto;
			user-select: auto;

			transition: 0.4s;
		}
	}

	@media (max-width: 820px) {
		.project-info {
			height: 100%;
			overflow-y: scroll;
			justify-content: flex-start;
		}
	}
`;

export default ProjectContainer;
